import { combineReducers } from "redux"
import { query } from './queryReducer'

const queryReducers = combineReducers({
    query,
})

export default queryReducers